module.exports = __webpack_public_path__ + "static/media/Long-term-goal.34b996a0.svg";